const DRAWER_ID = 'CountryLanguageDrawer';
const OPEN_CLASS = 'country-language-drawer--open';

/**
 * @returns {HTMLElement | null}
 */
function getDrawer() {
  return document.getElementById(DRAWER_ID);
}

/**
 * @param {HTMLElement} drawer
 * @returns {HTMLDialogElement | null}
 */
function getDialog(drawer) {
  return drawer.querySelector('dialog');
}

/**
 * @param {HTMLElement} drawer
 */
function openDrawer(drawer) {
  const dialog = getDialog(drawer);
  if (dialog?.open) return;

  if ('showDialog' in drawer && typeof drawer.showDialog === 'function') {
    drawer.showDialog();
    return;
  }

  dialog?.showModal();
}

/**
 * @param {HTMLElement} drawer
 */
function closeDrawer(drawer) {
  const dialog = getDialog(drawer);
  if (!dialog?.open) return;

  if ('closeDialog' in drawer && typeof drawer.closeDialog === 'function') {
    drawer.closeDialog();
    return;
  }

  dialog.close();
}

/**
 * @param {HTMLElement} drawer
 */
function syncDrawerWithClass(drawer) {
  if (drawer.classList.contains(OPEN_CLASS)) {
    openDrawer(drawer);
  } else {
    closeDrawer(drawer);
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const drawer = getDrawer();
  if (!drawer) return;

  if (event.target.closest('[data-country-language-drawer-open]')) {
    event.preventDefault();
    drawer.classList.add(OPEN_CLASS);
    return;
  }

  if (event.target.closest('[data-country-language-drawer-close]')) {
    event.preventDefault();
    drawer.classList.remove(OPEN_CLASS);
  }
});

const drawer = getDrawer();

if (drawer) {
  drawer.addEventListener('dialog:close', () => {
    drawer.classList.remove(OPEN_CLASS);
  });

  const observer = new MutationObserver(() => syncDrawerWithClass(drawer));
  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  syncDrawerWithClass(drawer);
}

/**
 * Carry the active portal to the destination country storefront. The portal_id
 * cookie is scoped to the current domain, so append it as ?portal_id= which the
 * destination's PortalManager picks up on load. Never prevents default, so
 * native navigation / new-tab behaviour is kept.
 * @param {Event} event
 */
function carryPortalToCountryLink(event) {
  if (event instanceof KeyboardEvent && event.key !== 'Enter') return;
  if (!(event.target instanceof Element)) return;

  const anchor = event.target.closest('a[data-portal-carry-link]');
  if (!(anchor instanceof HTMLAnchorElement)) return;

  const portalId = window.PortalManager?.getPortalId?.();
  if (!portalId) return;

  const rawHref = anchor.getAttribute('href');
  if (!rawHref) return;

  let url;
  try {
    url = new URL(rawHref, window.location.href);
  } catch {
    return;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

  url.searchParams.set('portal_id', portalId);
  anchor.href = url.toString();
}

for (const eventName of ['click', 'auxclick', 'keydown']) {
  document.addEventListener(eventName, carryPortalToCountryLink, true);
}
